import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Navbar, Nav , Container} from "react-bootstrap"; 

const Header = (props) => {

    const { title } = props;
    // console.log('props.title',title);

    let location = useLocation();
    const [ path_name, set_path_name ] = useState('') ;

    useEffect(() => {
        if(!!title){
            document.title=title + ' | Kanchana Gupta';
        }
        else{
            document.title="Kanchana Gupta";
        }
        set_path_name(location.pathname);
    },[location, title]);

    // console.log('pathname',path_name);
    return (
        <> 
            <header>
                <Container>
                   <Navbar.Brand><Link to="/">Kanchana Gupta</Link></Navbar.Brand>                
                 </Container>                  
                    <Navbar bg="light" expand="lg">
                    <Container> 
                       
                        <Container>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                          <Navbar.Collapse id="basic-navbar-nav">                              
                            <Nav className="me-auto">
                                <Nav className={ (path_name === "/about" || path_name === "/cv") && ( "active" )} ><Link to="/about">About</Link></Nav>
                                <Nav className={ path_name === "/works" && ( "active" )}><Link to="/works">Works</Link></Nav>
                                <Nav className={ path_name === "/solo-shows" && ( "active" )}><Link to="/solo-shows">Solo Shows</Link></Nav>
                                <Nav className={ path_name === "/other-shows" && ( "active" )}><Link to="/other-shows">Other Shows</Link></Nav>
                                <Nav className={ path_name === "/publication" && ( "active" )}><Link to="/publication">Publications</Link></Nav>
                                <Nav className={ path_name === "/news" && ( "active" )}><Link to="/news">News</Link></Nav>
                                <Nav className={ path_name === "/videos" && ( "active" )}><Link to="/videos">Videos</Link></Nav>
                                {/* <Nav className={ (path_name === "/events/upcoming" ||  path_name === "/events/past") && ( "active" )}><Link to="/events/upcoming">Events</Link></Nav>          */}
                                <Nav.Link className={ (path_name === "/events/upcoming" ||  path_name === "/events/past") && ( "active" )} href={process.env.REACT_APP_PUBLIC_URL + "/events/upcoming"}>Events</Nav.Link>                        
                            </Nav>
                          </Navbar.Collapse>
                          </Container>
                    </Container>
                    </Navbar>
              
            </header>  
 
        </>
    )
}
export default Header;